import { useEffect, useState } from "react";
import Loader from "@element/Loader/Loader";
import { apiRequest, convertDateTime } from "@utils/service";
import Default from "@layout/Default/Default";
import { Link } from "react-router-dom";

interface Product {
  subscription_id: string;
  subscription_start_date: string;
  subscription_end_date: string;
  subject_name: string;
  group_name: string;
  exam_name: string;
}
const Subscriptions = () => {
  const [loading, setLoading] = useState(false);
  const [subscriptions, setSubscriptions] = useState<Product[]>([]);

  useEffect(() => {
    setLoading(true);
    apiRequest("active_subscriptions")
      .then((resp) => {
        if (resp.success === "true") {
          setSubscriptions(resp.data.reverse());
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <Default>
      {loading && <Loader />}
      <div className="d-flex justify-content-center">
        <div className="card">
          <div className="card-header d-flex justify-content-center">
            <h3>Subscriptions</h3>
            <Link to="/add-subscription" className="btn btn-primary w-10 position-absolute r-2">Add Subscription</Link>
          </div>
          <div className="card-body">
            <div className="row g-4 h-80vh overflow-auto">
              {subscriptions.map((subscription, key) => {
                const status =
                  new Date() > new Date(subscription.subscription_end_date)
                    ? "Expired"
                    : "Expiring On";
                const textColor = {
                  'Expired': "text-danger",
                  'Expiring On': "text-success",
                };
                return (
                  <div key={subscription.subscription_id} className="col-12">
                    <div className="row d-flex border p-2">
                      <div className="col-1 d-flex flex-column justify-content-center align-items-center border">
                        <h4>{key+1}</h4>
                      </div>
                      <div className="col-7">
                        {/* <div className="d-flex justify-content-left align-items-center p-0">
                          <h6>{subscription.group_name}</h6>
                        </div> */}
                        <div className="d-flex flex-column mt-2 gap-1 justify-content-between">
                          {/* <div className="d-flex justify-content-left">{subscription.exam_name}</div> */}
                          <small className="text-muted d-flex justify-content-left">
                            {subscription.subject_name}
                          </small>
                        </div>
                      </div>
                      <div className="col-2 d-flex flex-column justify-content-center align-items-end">
                        <p className={`mb-0 text-success`}>Start Date</p>
                        <small>{convertDateTime(subscription.subscription_start_date)}</small>
                      </div>
                      <div className="col-2 d-flex flex-column justify-content-center align-items-end">
                        <p className={`mb-0 ${textColor[status]}`}>{status}</p>
                        <small>{convertDateTime(subscription.subscription_end_date)}</small>
                      </div>
                      
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </Default>
  );
};

export default Subscriptions;
